var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#discord_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#discord_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.86 17.724q-.514 1.008-1.19 1.918a18.3 18.3 0 0 1-5.556-2.789c-.388-4.078.389-8.214 3.256-12.456A18.3 18.3 0 0 1 8.904 3q.32.575.58 1.18a16.9 16.9 0 0 1 5.028 0q.258-.606.58-1.18a18.2 18.2 0 0 1 4.53 1.394c2.485 3.634 3.72 7.732 3.264 12.46a18.2 18.2 0 0 1-5.56 2.788 13.3 13.3 0 0 1-1.19-1.917m-9.69-1.242a13.05 13.05 0 0 0 11.109 0m-9.202-2.138c-1.083 0-1.978-.982-1.978-2.191 0-1.21.864-2.2 1.974-2.2s1.999.99 1.98 2.2c-.02 1.209-.873 2.191-1.976 2.191m7.295 0c-1.085 0-1.976-.982-1.976-2.191 0-1.21.864-2.2 1.976-2.2s1.993.99 1.974 2.2c-.019 1.209-.87 2.191-1.974 2.191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discord_svg__b",
    x1: 21.031,
    x2: -19.056,
    y1: 3.459,
    y2: 23.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "discord_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDiscord;